import { render } from "./InputOTPWithResend.vue?vue&type=template&id=46ee7d0b&scoped=true"
import script from "./InputOTPWithResend.vue?vue&type=script&lang=js"
export * from "./InputOTPWithResend.vue?vue&type=script&lang=js"

import "./InputOTPWithResend.vue?vue&type=style&index=0&id=46ee7d0b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46ee7d0b"]])

export default __exports__